import React from "react"
import Edges from "../../Edges"

const ReviewsPagination = ({ count, onChange, page, pages }) => {
  return (
    <Edges size="md">
      <nav className="flex items-center justify-between border-gray-200 px-4 sm:px-0">
        <div className="-mt-px flex w-0 flex-1">
          {page !== 1 && (
            <button
              onClick={e => onChange(e, page - 1)}
              className="inline-flex cursor-pointer items-center  pt-4 pr-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-darkBlue"
            >
              <svg
                className="mr-3 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                  clip-rule="evenodd"
                />
              </svg>
              Previous
            </button>
          )}
        </div>
        <div className="hidden md:-mt-px md:flex">
          {pages.map((item, index) => {
            return (
              <button
                key={index}
                onClick={e => onChange(e, index + 1)}
                className={
                  index + 1 === page
                    ? "inline-flex cursor-pointer items-center px-4 pt-4 text-sm font-black text-gray-500 hover:border-gray-300 hover:text-darkBlue"
                    : "inline-flex cursor-pointer items-center px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-darkBlue"
                }
              >
                {index + 1}{" "}
              </button>
            )
          })}
        </div>
        <div className="-mt-px flex w-0 flex-1 justify-end">
          {page !== count && (
            <button
              onClick={e => onChange(e, page + 1)}
              className="inline-flex cursor-pointer items-center border-transparent pt-4 pl-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-darkBlue"
            >
              Next
              <svg
                className="ml-3 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          )}
        </div>
      </nav>
    </Edges>
  )
}

export default ReviewsPagination
